import { render, staticRenderFns } from "./SaveContentTypeModal.vue?vue&type=template&id=5db7cb38&"
import script from "./SaveContentTypeModal.vue?vue&type=script&lang=ts&"
export * from "./SaveContentTypeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports